import { Notification } from "@/core/services/api/interfaces/manager/Notification";
import { Report } from "@/core/services/api/interfaces/manager/Report";
import ApiService from "@/core/services/ApiService";
import { ImportItem } from "@/core/services/api/interfaces/manager/ImportItem";

export class DownloaderService {
  downloadNotification(notification: Notification) {
    if (!this.isDownloadableNotification(notification)) {
      return;
    }
    const notificationable = notification.notificationable as Report;
    ApiService.manager.report
      .download(notificationable)
      .then((response) =>
        ApiService.asFileDownload(response, notificationable.filename as string)
      )
      .catch(console.error);
  }
  isDownloadableNotification(notification: Notification): boolean {
    return (
      notification.notificationable &&
      "actions" in notification.notificationable &&
      "is_downloadable" in notification.notificationable.actions &&
      notification.notificationable.actions.is_downloadable &&
      "filename" in notification.notificationable
    );
  }
  isDownloadableImportErrors(importItem: ImportItem): boolean {
    return !!(importItem.actions.has_errors && importItem.errors?.length);
  }

  downloadImportErrors(importItem: ImportItem) {
    if (!this.isDownloadableImportErrors(importItem)) {
      return;
    }
    ApiService.manager.import
      .downloadErrorsFile(importItem)
      .then((response) =>
        ApiService.asFileDownload(response, importItem.file_name as string)
      )
      .catch(console.error);
  }
}

export default new DownloaderService();
